<div class="container mt-4">
  <h1 class="h3 mb-2 text-gray-800"><i class="fas fa-list"></i> {{ categoryI18n?.allTitleI18n }}</h1>
  <p class="mb-4">The Category module is a crucial part of the library management software, designed to help organize and classify books, media, and other resources. It allows librarians to create, manage, and publish categories, making it easier for users to navigate and find specific types of resources.</p>

  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#Overview">
        <i class="fas fa-chart-bar mr-2"></i> Overview
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#List">
        <i class="fas fa-list mr-2"></i> List
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#UserManual">
        <i class="fas fa-book mr-2"></i> User Manual
      </a>
    </li>
  </ul>

  <div class="tab-content">
    <!-- Overview tab content -->
    <div id="Overview" class="tab-pane custom-tab-pane">
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">
                <h4 class="text-center">Books by Category</h4> <!-- Title for Bar Chart -->
                <ngx-charts-bar-vertical
                    [results]="barChartData"
                    [view]="[400,300]"
                    [scheme]="'cool'"
                    [gradient]="true"
                    [xAxis]="true"
                    [yAxis]="true"
                    [legend]="false"
                    [showXAxisLabel]="true"
                    [showYAxisLabel]="true"
                    xAxisLabel="Category"
                    yAxisLabel="Number of Books">
                </ngx-charts-bar-vertical>
            </div>
            <div class="col-md-6">
                <h4 class="text-center">Book Distribution by Genre</h4> <!-- Title for Pie Chart -->
                <ngx-charts-pie-chart
                    [results]="pieChartData"
                    [view]="[400,300]"
                    [scheme]="'cool'"
                    [legend]="false"
                    [explodeSlices]="false"
                    [labels]="true">
                </ngx-charts-pie-chart>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <h4 class="text-center">Trend of Book Sales Over Time</h4> <!-- Title for Line Chart -->
                <ngx-charts-line-chart
                    [results]="lineChartData"
                    [view]="[400,300]"
                    [scheme]="'cool'"
                    [legend]="false"
                    [xAxis]="true"
                    [yAxis]="true"
                    [autoScale]="true">
                </ngx-charts-line-chart>
            </div>
            <div class="col-md-6">
                <h4 class="text-center"> Book Sales by Genre</h4> <!-- Title for Doughnut Chart -->
                <ngx-charts-pie-chart
                    [results]="doughnutChartData"
                    [view]="[400,300]"
                    [scheme]="'cool'"
                    [legend]="false"
                    [explodeSlices]="false"
                    [doughnut]="true"
                    [labels]="true">
                </ngx-charts-pie-chart>
            </div>
        </div>
    </div>
    
    </div>

    <!-- List tab content -->
    <div id="List" class="tab-pane show active custom-tab-pane">
      <div class="container-fluid">
        <div *ngIf="loading; else loaded">
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>

        <ng-template #loaded>
          <!-- DataTales Example -->
          <app-statistics-category [categoryI18n]="categoryI18n"></app-statistics-category>
          <div class="card mb-4">
            <div class="card-body">
              <!-- add category -->
              <div class="table-responsive">
                <!-- category list -->
                <app-category-list
                  (editEvent)="edit($event)"
                  (deleteEvent)="delete($event)"
                  [categories]="categorys$"
                  [categoryI18n]="categoryI18n">
                </app-category-list>

                <!-- modal category -->
                <app-modal-category [categoryI18n]="categoryI18n" [id]="id"></app-modal-category>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- User Manual tab content -->
    <div id="UserManual" class="tab-pane custom-tab-pane">
      <!-- User Manual content here -->
      <div>
         <!-- <markdown [src]="markdownContent" [data]="markdownContent"></markdown>  -->
          <div  [innerHTML]="markdownContent"></div>
      </div>
    </div>
  </div>
</div>
